module.exports = __webpack_public_path__ + "img/KO_H.b7700224.png";